module.exports = __webpack_public_path__ + "img/IWM.ebeae2bb.png";